import React from 'react';

import styled from 'styled-components';

import { theme, Button, Popconfirm } from 'components';
import { Button as ButtonV2 } from '@bb/elements-web-rebranding';
import { ContactType } from '@bb/contacts';
import { featureEnabled } from 'utils';
import {
  DRAWER_FOOTER_HEIGHT,
  CONTACT_MODAL_POPCONFIRM_WIDTH,
} from '../constants';
import { ContactDrawerMode } from '../types';

interface DrawerFooterProps {
  disabled: boolean;
  onCancel?: () => void;
  onSave?: () => void;
  working: boolean;
  offsetTop?: number;
  type: ContactType;
  mode: ContactDrawerMode;
}

const DrawerFooter: React.FC<DrawerFooterProps> = ({
  disabled,
  onCancel,
  onSave,
  working,
  offsetTop,
  type,
  mode,
}) => {
  const displayPopconfirm = type === ContactType.Client && mode === 'edit';

  const saveButton = featureEnabled('supraRebrandingFeature', 1) ? (
    <ButtonV2
      onClick={displayPopconfirm ? undefined : onSave}
      loading={working}
      disabled={disabled}
      dataCy="contact-save-button"
      size="small"
      styleOverride={{ minWidth: '70px', marginLeft: 'auto' }}
    >
      Save
    </ButtonV2>
  ) : (
    <SaveButton
      onClick={!displayPopconfirm && onSave}
      loading={working}
      disabled={disabled}
      data-cy="contact-save-button"
    >
      Save
    </SaveButton>
  );
  return (
    <Container>
      <CancelButton onClick={onCancel} data-cy="contact-cancel-button">
        Cancel
      </CancelButton>
      {displayPopconfirm ? (
        <Popconfirm
          okText="Continue"
          overlayStyle={{
            width: CONTACT_MODAL_POPCONFIRM_WIDTH,
            zIndex: 2002,
          }}
          placement="bottomLeft"
          title="Saving this info will update the contact's information across the entire system."
          onConfirm={onSave}
        >
          {saveButton}
        </Popconfirm>
      ) : (
        saveButton
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  position: absolute;
  bottom: 0px;
  padding: 16px 20px;
  border-top: 1px solid ${theme.gray4};
  width: 100%;
  height: ${DRAWER_FOOTER_HEIGHT}px;
  background-color: ${theme.white};
`;

const CancelButton = styled(Button).attrs({ type: 'text' })`
  margin-right: auto;
`;

const SaveButton = styled(Button).attrs({ type: 'primary' })`
  margin-left: auto;
`;

export default DrawerFooter;
